<script setup lang="ts">
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'
import GwMenuNew from '@/components/lib/GwMenuNew/GwMenuNew.vue'
import GwDialogTemplate from '@/components/lib/GwDialogTemplate/GwDialogTemplate.vue'

export type DeleteType = 'selected' | 'all'
interface GwDeleteProps {
  btnOpenerText: string
  modalTitle: string
  modalText: string
  btnDeleteText: string
  btnDeleteAllText?: string
  modalTextDeleteAllPrompt?: string
}

defineProps<GwDeleteProps>()

const emit = defineEmits<{
  delete: [value: DeleteType]
}>()

const handleDelete = (type: 'selected' | 'all') => {
  emit('delete', type)
}
</script>
<template>
  <GwMenuNew
    transitionVariant="dialog"
    boxVariant="box_dialog"
  >
    <template #opener="{ listeners }">
      <GwBtn
        variant="btn_alert"
        icon="mdi-delete"
        v-bind="$attrs"
        v-on="listeners"
      >
        {{ btnOpenerText }}
      </GwBtn>
    </template>
    <template #content="{ methods: { close } }">
      <GwDialogTemplate
        :modalTitle
        :modalText
      >
        <template #actions>
          <GwMenuNew
            v-if="btnDeleteAllText"
            isInside
            transitionVariant="dialog"
            boxVariant="box_dialog"
          >
            <template #opener="{ listeners: tListeners }">
              <GwBtn
                variant="btn_text_grey_white"
                icon="mdi-delete-alert"
                class="ml-auto mr-2"
                data-tst="btn_delete_all"
                v-on="tListeners"
              >
                {{ btnDeleteAllText }}
              </GwBtn>
            </template>
            <template #content="{ methods: { close } }">
              <GwDialogTemplate
                :modalTitle
                :modalText="modalTextDeleteAllPrompt"
              >
                <template #actions>
                  <GwBtn
                    variant="btn_alert"
                    icon="mdi-delete-alert"
                    data-tst="btn_delete_all_confirm"
                    @click="handleDelete('all'), close()"
                  >
                    {{ btnDeleteAllText }}
                  </GwBtn>
                </template>
              </GwDialogTemplate>
            </template>
          </GwMenuNew>
          <GwBtn
            v-if="btnDeleteText"
            variant="btn_alert"
            icon="mdi-delete"
            data-tst="btn_delete_selected"
            @click="handleDelete('selected'), close()"
          >
            {{ btnDeleteText }}
          </GwBtn>
        </template>
      </GwDialogTemplate>
    </template>
  </GwMenuNew>
</template>
